import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

// AuthContext.jsx
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storage = localStorage.getItem('accessToken') ? localStorage : sessionStorage;

    const accessToken = storage.getItem('accessToken');
    const username = storage.getItem('username');
   
    
    const branch = storage.getItem('branch');

    if (accessToken) {
      setToken(accessToken);
      setUser({ username,  branch });
    }

    setLoading(false);
  }, []);

  const logout = () => {
    localStorage.clear();
    sessionStorage.clear();
    setToken('');
    setUser(null);
  };

  const value = {
    token,
    user,
    username: user?.username || '',

    
    branch: user?.branch || '',
    logout,
    loading,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
